import officeImage from "../assets/office_furniture.jpg";
import cleaningImage from "../assets/cleaning_countertops.jpg";
import headerBg from "../assets/telephone_booth.jpg";
import {
  COMPANY_ADDRESS,
  COMPANY_EMAIL,
  COMPANY_PHONE,
  socialLinks,
  WHATSAPP_URL,
} from "../siteData";

const contactItems = [
  { title: "Phone", value: COMPANY_PHONE, href: "tel:+255658902790" },
  {
    title: "Email",
    value: COMPANY_EMAIL,
    href: `mailto:${COMPANY_EMAIL}`,
  },
  { title: "Address", value: COMPANY_ADDRESS, href: null },
];

export default function ContactUsContent() {
  return (
    <>
      <section
        className="page-hero page-hero-contact"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      >
        <div className="container">
          <div className="page-hero-content">
            <h1 data-aos="fade-right" data-aos-delay="100">
              Let&apos;s connect and build a dependable working relationship.
            </h1>
            <p data-aos="fade-up" data-aos-delay="200">
              Reach out for supply inquiries, cleaning service discussions, or
              partnership opportunities. We are ready to respond with clarity and
              speed.
            </p>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="row g-4">
            {contactItems.map((item) => (
              <div key={item.title} className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="contact-card-panel h-100">
                  <h3>{item.title}</h3>
                  {item.href ? <a href={item.href}>{item.value}</a> : <p>{item.value}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-shell section-soft">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="editorial-panel h-100">
                <h2>How we can help</h2>
                <p>
                  We respond to product sourcing requests, repeat supply needs,
                  home and office cleaning inquiries, and broader procurement
                  conversations with a business-minded approach.
                </p>
                <div className="bullet-grid">
                  <div className="bullet-grid-item">
                    <span />
                    <p>Supply and procurement support for diverse product categories</p>
                  </div>
                  <div className="bullet-grid-item">
                    <span />
                    <p>Residential and deep cleaning service coordination</p>
                  </div>
                  <div className="bullet-grid-item">
                    <span />
                    <p>Timely delivery planning for growing customer demand</p>
                  </div>
                </div>
                <div className="hero-actions mt-4">
                  <a href="tel:+255658902790" className="btn btn-primary">
                    Call Now
                  </a>
                  <a href={`mailto:${COMPANY_EMAIL}`} className="btn btn-outline-primary">
                    Send Email
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="contact-image-grid">
                <div className="feature-image-card" data-aos="fade-up" data-aos-delay="200">
                  <img src={officeImage} alt="MS Universal office and support team" />
                </div>
                <div className="feature-image-card" data-aos="fade-up" data-aos-delay="300">
                  <img src={cleaningImage} alt="MS Universal cleaning solutions" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="100">
              <div className="feedback-panel h-100">
                <span className="section-kicker">Feedback Section</span>
                <h2>Tell us how your experience feels.</h2>
                <p>
                  If you have feedback, a question, or a request for improved
                  service, reach out on WhatsApp and our team will respond
                  directly.
                </p>
                <div className="hero-actions mt-4">
                  <a
                    href={WHATSAPP_URL}
                    className="btn btn-whatsapp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Send Feedback on WhatsApp
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-5" data-aos="fade-up" data-aos-delay="180">
              <div className="contact-card-panel h-100">
                <h3>Follow and reach us</h3>
                <p>
                  Connect with the business through our contact channels and
                  social platforms.
                </p>
                <div className="social-link-grid">
                  {socialLinks.map((link) => {
                    const Icon = link.icon;
                    return (
                      <a
                        key={link.label}
                        href={link.href}
                        className="social-link-card"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="social-link-card-icon">
                          <Icon />
                        </span>
                        <span>{link.label}</span>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
